<template>
	<v-card flat outlined>
		<v-container fluid class="pb-0">
			<v-row>
				<v-col cols="12" lg="12" class="pb-0 pt-0">
					<v-card flat class="pb-0 pt-0">
						<v-card-text class="pb-0">
							<v-row>
								<v-col class="pb-0 pt-0">
									<v-card-title class="justify-center align-center pa-2 pb-0 pt-0">
										{{ $t('titles.candidatePaymentContracts') }}</v-card-title
									>
								</v-col>
							</v-row>
							<v-row>
								<v-col class="pt-0">
									<TheTable
										:additional-filters="candidatePaymentContractsTable.additionalFilters"
										:default-sort="candidatePaymentContractsTable.defaultSort"
										:excel="false"
										:fields="candidatePaymentContractsTable.headers"
										:header-selection-key="'candidate-payment-contracts-headers'"
										:height="candidatePaymentContractsTable.height"
										:total-records="candidatePaymentContractsTable.total"
										@headers="selectHeaders"
										@reload="reloadData"
									>
										<tr
											v-for="(item, key) in candidatePaymentContractsTable.items"
											:key="key"
											:class="{ 'cursor-pointer': true }"
										>
											<td
												v-if="candidatePaymentContractsTable.selectedHeaders.includes('id')"
												@click="redirect(item.id)"
											>
												{{ item.id }}
											</td>
											<td
												style="text-align: right"
												v-if="
													candidatePaymentContractsTable.selectedHeaders.includes(
														'total_bruto'
													)
												"
												@click="redirect(item.id)"
											>
												{{
													item.total_bruto != null
														? Number.isInteger(item.total_bruto)
															? item.total_bruto.toLocaleString('hr') + ',00'
															: /^\d+\.\d{1}$/.test(item.total_bruto.toString())
															? item.total_bruto.toLocaleString('hr') + '0'
															: item.total_bruto.toLocaleString('hr')
														: ''
												}}
											</td>
											<td
												style="text-align: right"
												v-if="candidatePaymentContractsTable.selectedHeaders.includes('payed')"
												@click="redirect(item.id)"
											>
												{{
													item.payed != null
														? Number.isInteger(item.payed)
															? item.payed.toLocaleString('hr') + ',00'
															: /^\d+\.\d{1}$/.test(item.payed.toString())
															? item.payed.toLocaleString('hr') + '0'
															: item.payed.toLocaleString('hr')
														: ''
												}}
											</td>
											<td
												style="text-align: right"
												v-if="candidatePaymentContractsTable.selectedHeaders.includes('debt')"
												@click="redirect(item.id)"
											>
												{{
													item.debt != null
														? Number.isInteger(item.debt)
															? item.debt.toLocaleString('hr') + ',00'
															: /^\d+\.\d{1}$/.test(item.debt.toString())
															? item.debt.toLocaleString('hr') + '0'
															: item.debt.toLocaleString('hr')
														: ''
												}}
											</td>
											<td
												v-if="candidatePaymentContractsTable.selectedHeaders.includes('status')"
												@click="redirect(item.id)"
											>
												{{ item.payment_contract_status.name }}
											</td>
										</tr>
									</TheTable>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'CandidatePaymentContracts',
	components: { TheTable },
	data: function () {
		return {
			candidatePaymentContractsTable: {
				selectedHeaders: [],
				headers: [
					{
						text: this.$t('fields.id'),
						value: 'id',
						type: '',
						allowFilter: true,
						sortable: true,
					},
					{
						text: this.$t('fields.amount'),
						value: 'total_bruto',
						type: '',
						allowFilter: true,
						sortable: false,
						alignRight: true,
					},
					{
						text: this.$t('fields.payed'),
						value: 'payed',
						type: '',
						allowFilter: true,
						sortable: false,
						alignRight: true,
					},
					{
						text: this.$t('fields.left'),
						value: 'debt',
						type: '',
						allowFilter: true,
						sortable: false,
						alignRight: true,
					},
					{
						text: this.$t('fields.status'),
						value: 'status',
						type: '',
						allowFilter: true,
						sortable: false,
					},
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'id',
					descending: true,
				},
			},
		};
	},
	methods: {
		selectHeaders(headers) {
			this.candidatePaymentContractsTable.selectedHeaders = headers;
		},
		redirect(id) {
			if (!(parseInt(id, 10) > 0)) {
				this.$alert(this.$t('alerts.basicError'));
				return;
			}
			this.$router.push('/payment-contracts/' + id);
		},
		reloadData(request) {
			this.candidatePaymentContractsTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'candidate-payment-contracts/' + this.$route.params.id,
				request,
				(data, success) => {
					if (success) {
						vm.candidatePaymentContractsTable.items = data.items;
						vm.candidatePaymentContractsTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.candidatePaymentContractsTable.height = window.innerHeight - 300 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
